import { NgModule, LOCALE_ID, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Globalization } from '@awesome-cordova-plugins/globalization/ngx';
import { LocaleService } from './services/locale.service';

const appInitializer = (localeService: LocaleService) => async () => await localeService.initLocaleName();

@NgModule({
	declarations: [],
	imports: [CommonModule],
	providers: [
		{
			provide: LOCALE_ID,
			useFactory: (localeService: LocaleService) => localeService.getLocaleName(),
			deps: [LocaleService]
		},
		{
			provide: APP_INITIALIZER,
			// since the globalization plugin returns a promsise
			// and use factory does not suport promises, we to initialize
			useFactory: appInitializer,
			deps: [LocaleService],
			multi: true
		},
		Globalization
	]
})
export class LocalizationModule {}
